import React from "react";
import "../../../styles-v2/profile-menu/v2-shared-table.css";

/**
 * ReusableTable
 * @param {Array} columns - [{ key, label, render? }]
 * @param {Array} data - array of row objects
 */
const ReusableTable = ({ columns, data }) => {
  return (
    <div className="v2-shared-tbl-wrap">
      <table className="v2-shared-tbl">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReusableTable;
